import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('reporting-ui-components', {
  library: 'reporting-ui-components'
});